import { Component, OnInit } from '@angular/core';
import { AppConfig } from '../../../../app.config';
import { HelpersService } from '../../../../services/helpers.service';
import { CountriesService } from '../../../../services/countries.service';

@Component({
  selector: 'app-in-app-payment-configuration',
  templateUrl: './in-app-payment-configuration.component.html',
  styleUrls: ['./in-app-payment-configuration.component.scss'],
})
export class InAppPaymentConfigurationComponent implements OnInit {
  public partner: any = {};
  public allowStripe: boolean = false;
  public allowPeachPayments: boolean = false;

  constructor(
    public appConfig: AppConfig,
    public helperService: HelpersService,
    public countriesService: CountriesService,
  ) {}

  ngOnInit() {
    this.partner = this.helperService.getPartnerData();
    this.countriesService
      .getAllCountry(this.partner.Country)
      .subscribe((country) => {
        if (
          country &&
          country.paymentProvider &&
          country.paymentProvider.toUpperCase() === 'STRIPE'
        ) {
          this.allowStripe = true;
        }
      });
  }
}
